
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#56BFC7","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","clip-path":"url(#clip0_25476_41092)"}},[_c('path',{attrs:{"d":"M21.931 23.83H5.646a2.572 2.572 0 110-5.142h14.571a1.714 1.714 0 001.714-1.714V3.259a1.715 1.715 0 00-1.714-1.714H5.646a2.572 2.572 0 00-2.572 2.503V21.19M20.215 18.688v5.143"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_25476_41092"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5 .62)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    